import { ModelFactory } from "../../ModelFactory";

export class ReportedMonth {
  constructor(
    public readonly month: Date,
    public readonly value: number,
  ) {
  }
}

class ReportedMonthFactory extends ModelFactory<ReportedMonth> {
  protected fromJson(json: any): ReportedMonth {
    return new ReportedMonth(
      new Date(json['year'], json['month'] - 1, 1),
      json['value'],
    );
  }
}
export const reportedMonthFactory = new ReportedMonthFactory();
